/**
 * "Available for work" on the Progress page, read from the real setting.
 *
 * The card this replaces kept its own copy in localStorage: switching it on
 * told the user they were available, but nothing reached the server, so the
 * Marketplace never showed them. Availability is the portfolio's
 * `availableForHire` (changed on the Portfolio page); this card shows it and
 * links there.
 */

import { Link } from 'react-router-dom';
import { useGetMyPortfolioQuery } from '../../store/api/portfolioApi';

export function HireAvailabilityCard() {
  const { data: portfolio, isLoading, isError } = useGetMyPortfolioQuery();

  return (
    <div className="card" data-testid="hire-availability-card">
      <div className="card-header">
        <h2 className="font-semibold text-gray-900">Available for Work</h2>
      </div>
      <div className="card-body space-y-2">
        {isLoading ? (
          <p className="text-sm text-gray-500">Loading…</p>
        ) : isError || !portfolio ? (
          <p className="text-sm text-gray-500">Your availability could not be loaded.</p>
        ) : portfolio.availableForHire ? (
          <p className="text-sm text-gray-700">
            You are marked as available for hire.
            {!portfolio.isPublic && ' Your portfolio is not public, so the Marketplace does not list you.'}
          </p>
        ) : (
          <p className="text-sm text-gray-700">You are not marked as available for hire.</p>
        )}
        <Link to="/portfolio" className="inline-block text-sm font-medium text-primary-600 hover:underline">
          Manage on your Portfolio
        </Link>
      </div>
    </div>
  );
}
